import { Heading, Image } from "@george-labs.com/design-system"
import { IMAGE_SIZE } from "./offerHelperComponents"
import { OfferNavButtons } from "./OfferNavButtons"

interface IOfferInfoComponentProps {
  buttonText: string
  textContent: React.ReactNode
  otherContent?: React.ReactNode
  headerText: string
  imageUrl: string
  onButtonClicked: () => void
}

const OfferInfoComponent: React.FC<IOfferInfoComponentProps> = ({
  buttonText,
  textContent,
  otherContent,
  headerText,
  imageUrl,
  onButtonClicked,
}) => {
  return (
    <>
      <div
        style={{
          textAlign: "center",
          color: "white",
          marginBottom: "2rem",
        }}
      >
        <Image
          src={imageUrl}
          alt=""
          className="mb-3 mt-1"
          height={IMAGE_SIZE}
          width={IMAGE_SIZE}
        />

        <Heading
          level={1}
          style={{
            color: "white",
            fontSize: "2rem",
            textAlign: "center",
            marginBottom: "2rem",
            paddingTop: "0px",
          }}
        >
          {headerText}
        </Heading>

        {textContent}
      </div>

      {otherContent}

      <OfferNavButtons
        onNextButtonClicked={onButtonClicked}
        nextButtonText={buttonText}
        isAlternativeColored
      />
    </>
  )
}

export default OfferInfoComponent
